// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_PLACE_IMAGE_IN_ARTICLE_WITH_FOLLOWING_CODE = "Pre vlo\u017eenie obr\u00e1zku pou\u017ei tento k\u00f3d:";
